/**
 * Created by YJZX-LCH on 2017-04-12.
 */

import localStorage from '../../localstorage/localStorage';

const state = {
  user: JSON.parse(localStorage.getData('user')), //存储用户信息
  loginInfo: JSON.parse(localStorage.getData('loginInfo')) //存储账号密码
};

const getters = {
  getUserInfo (state) { //存储用户信息
    return state.user;
  },
  getLoginInfo (state) {  //存储账号密码
    return state.loginInfo;
  }
};

const mutations = {
  clearUserInfo (state) {
    state.user = false;
    localStorage.removeData('user');
    localStorage.removeData('token');
  },
  receivedUserInfoFromRemote (state, payload) {
    state.user = payload.user[0];
    localStorage.addData('user', payload.user[0]);
    localStorage.addData('token', payload.user[0].token);
  },
  receivedUserInfoFromLocal (state, user) {
    state.user = user;
  },
  reIcon (state, payload) {
    state.user.avatar = payload.icon;
    localStorage.addData('user', state.user);
  },
  clearLoginInfo (state) {
    state.loginInfo = false;
    localStorage.removeData('loginInfo');
  },
  saveLoginInfo (state, loginInfo) {
    state.loginInfo = loginInfo;
    localStorage.addData('loginInfo', state.loginInfo);
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js